import { render, staticRenderFns } from "./ParametricProject.vue?vue&type=template&id=16cb3914"
import script from "./ParametricProject.vue?vue&type=script&lang=js"
export * from "./ParametricProject.vue?vue&type=script&lang=js"
import style0 from "./ParametricProject.vue?vue&type=style&index=0&id=16cb3914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports